import { useState } from "react";
import { useNavigate } from "react-router";
import { Button } from "../components/ui/Button";
import { Card } from "../components/ui/Card";
import { Input } from "../components/ui/Input";
import { realApiClient } from "../services/apiClient";

export function LoginPage() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("buyer@greenvalleyrx.example");
  const [password, setPassword] = useState("MatchRxDemo!2026");
  const [error, setError] = useState<string | null>(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  return (
    <Card className="mx-auto max-w-2xl p-8">
      <h1 className="text-4xl font-black">Login</h1>
      <p className="mt-3 text-slate-600">Sign in with a seeded Cognito dev user to load live MatchRx API data.</p>
      <form className="mt-6 space-y-4" onSubmit={async event => {
        event.preventDefault();
        setIsSubmitting(true);
        setError(null);
        try {
          await realApiClient.login(email, password);
          navigate("/marketplace");
        } catch (err) {
          setError(err instanceof Error ? err.message : "Login failed");
        } finally {
          setIsSubmitting(false);
        }
      }}>
        <Input label="Email" value={email} onChange={event => setEmail(event.currentTarget.value)} />
        <Input label="Password" type="password" value={password} onChange={event => setPassword(event.currentTarget.value)} />
        {error && <p className="rounded-xl border border-red-200 bg-red-50 p-3 text-sm text-red-700">{error}</p>}
        <button className="rounded-2xl bg-slate-950 px-5 py-3 font-black text-white disabled:opacity-60" type="submit" disabled={isSubmitting}>{isSubmitting ? "Signing in…" : "Continue"}</button>
      </form>
    </Card>
  );
}

export function RegisterPage() { return <AuthFrame title="Register pharmacy" cta="Continue onboarding" next="/auth/onboarding" />; }
export function OnboardingPage() { return <AuthFrame title="Onboarding / verification" cta="Finish prototype" next="/marketplace" />; }

function AuthFrame({ title, cta, next }: { title: string; cta: string; next: string }) {
  return <Card className="mx-auto max-w-2xl p-8"><h1 className="text-4xl font-black">{title}</h1><div className="mt-6 space-y-4">{["Pharmacy legal name", "Email", "NPI/NABP", "State license"].map(field => <Input key={field} label={field} placeholder={field} />)}</div><Button className="mt-6" href={next}>{cta}</Button></Card>;
}
